import { combineReducers } from 'redux'
import * as types from '../../utils/actionTypes'
import { createReducer } from '../../utils/helpers'

const initialState = {
  config: {
    title: 'Haustyp',
    path: 'haustyp',
    selectionKey: 'nodes',
    component: 'HouseType',
  },
  rootNode: {},
}

export const config = createReducer(initialState.config, {})


const setHouseType = (state, payload) => ({
  ...state,
  ...payload,
})

export const rootNode = createReducer(initialState.rootNode, {
  [types.SET_HOUSETYPE]: setHouseType,
})

// Default Export
export default combineReducers({
  config,
  rootNode,
})



// WEBPACK FOOTER //
// ./src/modules/houseType/reducers.js